import React from "react";
import {
    Drawer,
    Space,
    Button,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";

//compoenntes
import { IconSAT } from "../../Widgets/Iconos";
import FacturaTimbradoForm from "./FacturaTimbradoForm";
import "../../../Styles/Modules/Finanzas/DrawerTimbrado.scss";

/**
 * Drawer contenedor principal para el formulario de timbrado de facturas (CFDI)
 * 
 * @component
 * @param {Function} onClose - Función callback que se ejecuta al cerrar el drawer
 * @param {boolean} visible - Controla la visibilidad del drawer
 * @param {string} [tipo="NC" | "PE"] - Tipo de comprobante fiscal (ej: "NC" para Nota de Crédito, "PE" para Comprobante de Pago)
 * @param {string} [clienteId] - ID del cliente (usado como fallback si cliente._id no existe)
 * @param {Object} [cliente] - Objeto completo del cliente con sus datos (debe incluir _id)
 * @param {string} [transaccionId] - ID de la transacción relacionada (opcional, obligatorio para "PE")
 * @param {string} [ordenId] - ID de la orden relacionada (opcional, obligatorio para "PE")
 */
export default function DrawerFactura(props) {

    let { onClose, visible, tipo = "NC", clienteId } = props
    let [ loading, setLoading ] = React.useState(false)
    let [ disabled, setDisabled ] = React.useState(false)

    const timbradoOrden = React.createRef()

    /**
     * @description Cerramos y limpiamos el DRAWER de facturación.
     */
    let onCloseEvent = () => {
        onClose();
        setLoading(false)
        setDisabled(false)
    }

    return <Drawer
        title={<span className="title">Generación del Comprobante Fiscal Digital</span>}
        placement="right"
        onClose={onCloseEvent}
        open={visible}
        width={"90%"}
        style={{ maxWidth: "100%" }}
        destroyOnClose
        extra={
            <Space>
                <Button 
                    loading={loading} 
                    disabled={disabled} 
                    icon={<IconSAT 
                    size={14} 
                    color="currentColor" 
                    style={{ position: "relative", top: 2, right: 3 }} />} 
                    type="primary" 
                    onClick={() => timbradoOrden.current?.submit()}
                >
                    Timbrar
                </Button>
                <Button loading={loading} danger icon={<CloseOutlined />} onClick={onClose}>Cancelar</Button>
            </Space>
        }
    >  
        <FacturaTimbradoForm 
            ref={timbradoOrden} 
            tipoFactura={tipo} 
            cliente={props.cliente} 
            clienteId={clienteId ?? props.cliente?._id} 
            onCloseEvent={onCloseEvent}
            transaccionId={props.transaccionId}
            ordenId={props.ordenId}
        />
    </Drawer>
}